import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import Amplify, { Auth } from 'aws-amplify';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './redux/store';
import awsconfig from './aws-exports';

import './particles/i18next';

const graphql_headers = {
  graphql_headers: async () => {
    return { Authorization: (await Auth.currentSession()).getIdToken().getJwtToken() };
  }
};

Amplify.configure({ ...awsconfig, ...graphql_headers });

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Suspense fallback={<div>Loading ....</div>}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Suspense>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
